import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const Container = styled.div<{ color: string }>`
  color: ${({ color }) => color};
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const MessageReportStatusCount = ({ cell: { getValue, column } }: Props) => {
  const messageTemplate = column.id

  const count = String(getValue().value)

  const getColor = () => {
    switch (messageTemplate) {
      case "delivered":
        return "#2db2c8"
      case "pending":
        return "#f59e0b"
      case "failed":
        return "#ef4444"
      default:
        return "#000000"
    }
  }

  return <Container color={getColor()}>{count}</Container>
}

export default MessageReportStatusCount
